import React from "react";

function Recommendations() {
  // let anime = (
  //     <h3 class="topics">Anime</h3>
  //     <ul style="margin-top: unset;">
  //       <li>Steins;Gate</li>
  //       <li>I Want To Eat Your Pancreas</li>
  //       <li>A Silent Voice</li>
  //       <li>Violet Evergarden</li>
  //       <li>Your Lie in April</li>
  //       <li>Cowboy Bebop</li>
  //       <li>Attack on Titan</li>
  //       <li>Ghost Stories (English Dub)</li>
  //       By Season
  //       <li>Spring 2024 - </li>
  //       <li>Winter 2024 - Delicious in Dungeon</li>
  //       <li>Fall 2023 - Frieren: Beyond Journey's End</li>
  //       <li>Spring 2023 - Hell's Paradise</li>
  //       <li>Winter 2023 - The Eminence in Shadow</li>
  //       <li>Fall 2022 - Chainsaw Man</li>
  //       <li>Summer 2022 - Call of the Night / Lycoris Recoil</li>
  //       <li>Spring 2022 - Spy x Family / Summer Time Rendering / Ya Boy Kongming!</li>
  //       <li>Winter 2022 - My Dress-Up Darling</li>
  //       <li>Fall 2021 - Ranking of Kings</li>
  //       <li>Summer 2021 - Uramichi Oniisan</li>
  //       <li>Spring 2021 - Vivy: Fluorite Eye's Song / Odd Taxi</li>
  //       <li>Winter 2021 - Horimiya / Jobless Reincarnation / Wonder Egg Priority minus the last episode or so</li>
  //       <li>Fall 2020 - Jujutsu Kaisen / Tonikaku Kawaii</li>
  //       <li>Summer 2020 - Great Pretender</li>
  //       <li>Spring 2020 - Tower of God</li>
  //       <li>Winter 2020 - Dorohedoro</li>
  //       <li>Autumn 2019 - Cautious Hero: The Hero Is Overpowered but Overly Cautious</li>
  //       <li>Summer 2018 - Cop Craft</li>
  //       <li>Spring 2018 - Demon Slayer</li>
  //       <li>Fall 2018 - Rascal Does Not Dream of ... series</li>
  //       <li>Winter 2018 - Violet Evergarden</li>
  //     </ul>
  // )
  return (
    <div>
      <div>
        <p>I watch a lot of stuff, but here's what I would recommend.</p>
        <h2>TV shows</h2>
        <p>
          TV shows are hard because most episodes are around 40 minutes and span
          multiple seasons.
        </p>
        <ul>
          <li>Silicon Valley</li>
          <li>Love</li>
          <li>Stranger Things</li>
          <li>The Bear</li>
          <li>Ted Lasso</li>
          <li>The Marvelous Mrs. Maisel</li>
        </ul>
        <h2>Cartoons</h2>
        <ul>
          <li>Bojack Horseman</li>
          <li>Futurama</li>
          <li>Rick & Morty</li>
          <li>Archer</li>
          <li>Arcane</li>
          <li>The Dragon Prince</li>
          <li>
            Avatar: The Last Airbender(not the blue people and not the live
            action)
          </li>
          <li>Tear Along the Dotted Line</li>
        </ul>
      </div>
      <h1>music I listen to</h1>
      <div>
        <p>
          I listen to pretty much anything, but lately I'm been more into
          instrumental/hip-hop/music sung in languages I don't understand.
        </p>
        <h2>Artists I listen to while working</h2>
        <ul>
          <li>DJ Okawari</li>
          <li>Sigur Rós</li>
          <li>Yndi Halda</li>
          <li>RADWIMPS</li>
          <li>EVE</li>
          <li>Grieves</li>
          <li>Marshmello</li>
        </ul>
        <h2>Artists I've put on repeat</h2>
        <ul>
          <li>City Girl</li>
          <li>Juniper Vale</li>
          <li>X Ambassadors</li>
          <li>Grieves</li>
          <li>Of Monsters and Men</li>
          <li>Bon Iver</li>
        </ul>
        <h2>Songs I've put on repeat</h2>
        <ul>
          <li>Daylight - David Kushner</li>
          <li>Not Too Late - Lemaitre</li>
          <li>Take Me Out - Franz Ferdinand</li>
          <li>Valerian - Raujika</li>
          <li>A Little More - Hazzy</li>
          <li>Nuvole Bianche - Ludovico Einaudi, Alessia Tondo</li>
          <li>Welcome to the Black Parade - My Chemical Romance</li>
        </ul>
        <h2>Sad songs</h2>
        <ul>
          <li>Fallen - Gert Taberner</li>
          <li>Not That Simple - Mike Posner</li>
          <li>It's Ok - Tom Rosenthal</li>
          <li>The Night We Met - Lord Huron</li>
        </ul>
        <h2>Personal Favorites</h2>
        <ul>
          <li>Mr. Brightside - The Killers</li>
          <li>Daylight - Matt and Kim</li>
          <li>Venice - The Lighthouse and The Whaler</li>
          <li>You're Beautiful - James Blunt</li>
        </ul>
        <h2>Songs I recommend that you probably haven't heard of</h2>
        <ul>
          <li>Beautiful Things - Gungor</li>
          <li>Surgical Rewind - Will Champlin</li>
          <li>Sky High - SoulChef, Chima Anya</li>
          <li>Tied To Our Words - Late June</li>
          <li>Twenty Past Four - Kognitif</li>
        </ul>
      </div>
    </div>
  );
}

export default Recommendations;
